import React, { useCallback } from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';

import * as S from './styles';

export function Tanks({ data, station, onChangeRow }) {
  const handleChangeInput = useCallback(
    async ({ index, row, value, input, vars }) => {
      const isInput = document.getElementById(input);

      try {
        const { idarqueacao } = row;

        await api
          .get(`arqueacoes/${idarqueacao}/${station}/${value}`)
          .then((response) => {
            isInput.value = response.data.altura;

            const item = { ...row };

            item[vars.current] = response.data.altura;
            item[vars.other] = response.data.volume;

            onChangeRow({ key: index, value: item });
          });
      } catch (err) {
        isInput.value = '';
        isInput.focus();

        getToastErrors(err);
      }
    },
    []
  );

  return (
    <S.WrapperTabela>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell variant="head">{t('c.menu.stock.tanque')}</TableCell>
              <TableCell variant="head">{t('s.geral.alturainicial')}</TableCell>
              <TableCell variant="head">
                {t('s.operacao.turno.volinicontabil')}
              </TableCell>
              <TableCell variant="head">{t('s.geral.alturafinal')}</TableCell>
              <TableCell variant="head">{t('s.geral.volumefinal')}</TableCell>
              {/* <TableCell variant="head">
                {t('s.operacao.recebimentonf.volAbastecido')}
              </TableCell> */}
              <TableCell variant="head">
                {t('s.operacao.recebimentonf.volumemedido')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.codigotanquefisico}</TableCell>
                <TableCell>
                  <input
                    id={`in-${row.codigotanquefisico}`}
                    name="_"
                    type="number"
                    defaultValue={row.alturainicialdescarganftanque}
                    onKeyUp={({ target, key }) =>
                      key === 'Enter' &&
                      handleChangeInput({
                        index,
                        row,
                        value: target.value,
                        input: `in-${row.codigotanquefisico}`,
                        vars: {
                          current: 'alturainicialdescarganftanque',
                          other: 'volumeinicialdescarganftanque',
                        },
                      })
                    }
                    onBlur={({ target }) =>
                      handleChangeInput({
                        index,
                        row,
                        value: target.value,
                        input: `in-${row.codigotanquefisico}`,
                        vars: {
                          current: 'alturainicialdescarganftanque',
                          other: 'volumeinicialdescarganftanque',
                        },
                      })
                    }
                  />
                </TableCell>
                <TableCell>
                  {number(row.volumeinicialdescarganftanque, 2)}
                </TableCell>
                <TableCell>
                  <input
                    id={`fn-${row.codigotanquefisico}`}
                    name="_"
                    type="number"
                    defaultValue={row.alturafinaldescarganftanque}
                    onKeyUp={({ target, key }) =>
                      key === 'Enter' &&
                      handleChangeInput({
                        index,
                        row,
                        value: target.value,
                        input: `fn-${row.codigotanquefisico}`,
                        vars: {
                          current: 'alturafinaldescarganftanque',
                          other: 'volumefinaldescarganftanque',
                        },
                      })
                    }
                    onBlur={({ target }) =>
                      handleChangeInput({
                        index,
                        row,
                        value: target.value,
                        input: `fn-${row.codigotanquefisico}`,
                        vars: {
                          current: 'alturafinaldescarganftanque',
                          other: 'volumefinaldescarganftanque',
                        },
                      })
                    }
                  />
                </TableCell>
                <TableCell>
                  {number(row.volumefinaldescarganftanque, 2)}
                </TableCell>

                {/* Mostrar o volume abastecimento de cada tanque */}
                {/* <TableCell>
                  {number(row.volumesaidadescarganftanque, 2)}
                </TableCell> */}

                <TableCell>
                  {number(
                    row.volumefinaldescarganftanque -
                      row.volumeinicialdescarganftanque,
                    2
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tanks.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  station: PropTypes.string.isRequired,
  onChangeRow: PropTypes.func.isRequired,
};
